export default "__VITE_ASSET__CrGLBCir__"